import http from '@admin/http';
import { Metrics } from '../types';

function getMetricsCtor({ http }) {
  return async function getMetrics(startDate: string, endDate: string): Promise<Metrics[]> {
    const { data } = await http.get(
      `/lnpl/v1/failed-payment-analytics/notification-performance?startDate=${startDate}&endDate=${endDate}`,
    );
    return data;
  };
}

export default getMetricsCtor({ http });
